/** [PT-8334] Open/rules popup helpers — mirror accounts-core promotion-banner-ui. */

import {PromotionOffer, PromotionTier} from './types'

export const PROMOTION_RULES_MODAL_TITLE = 'Tauro 10x Account Rules'
export const PROMOTION_RULES_MODAL_SUBTITLE =
  'Today\'s rules pop-up, with the terms of every Factor in this offer.'
export const PROMOTION_OPEN_MODAL_TITLE = 'Open a Factorised Account'
export const PROMOTION_OPEN_MODAL_SUBTITLE =
  'Today\'s account opening, with the offer already chosen. Change the Factor here if you like.'
export const PROMOTION_RULES_ACCEPT_LABEL = 'I have read and accept the Tauro 10x Account Rules.'

export type PromotionRulesTableRow = {
  multiplier: number
  drawdownTriggerPercent: number
  clientProfitSplitPercent: number
  tauroProfitSplitPercent: number
  leverage: number
  minQualifyingDeposit: number
  maxQualifyingDeposit: number
}

export function promotionRulesTableRows(
  offers: readonly Pick<
    PromotionOffer,
    | 'multiplier'
    | 'drawdownTriggerPercent'
    | 'clientProfitSplitPercent'
    | 'tauroProfitSplitPercent'
    | 'leverage'
    | 'minQualifyingDeposit'
    | 'maxQualifyingDeposit'
  >[],
): PromotionRulesTableRow[] {
  return offers.map((offer) => ({
    multiplier: offer.multiplier,
    drawdownTriggerPercent: offer.drawdownTriggerPercent,
    clientProfitSplitPercent: offer.clientProfitSplitPercent,
    tauroProfitSplitPercent: offer.tauroProfitSplitPercent,
    leverage: offer.leverage,
    minQualifyingDeposit: offer.minQualifyingDeposit,
    maxQualifyingDeposit: offer.maxQualifyingDeposit,
  }))
}

/**
 * createOwnAccount must send a Factor that exists on the offer and is still open,
 * otherwise the server returns promotionNotAvailable.
 */
export function resolvePromotionOpenMultiplier(
  offers: readonly Pick<PromotionOffer, 'multiplier' | 'canOpen'>[],
  requested?: number | null,
): number | null {
  if (requested != null) {
    const exact = offers.find((offer) => offer.multiplier === requested && offer.canOpen)
    return exact ? exact.multiplier : null
  }
  return offers.find((offer) => offer.canOpen)?.multiplier ?? null
}

export function promotionOpenOfferSummary(input: {
  offer: Pick<
    PromotionOffer,
    | 'multiplier'
    | 'drawdownTriggerPercent'
    | 'clientProfitSplitPercent'
    | 'tauroProfitSplitPercent'
    | 'leverage'
    | 'minQualifyingDeposit'
    | 'maxQualifyingDeposit'
  >
  tier: Pick<PromotionTier, 'name' | 'deposit' | 'tradingBalance'>
  currency?: string
}): string {
  const currency = input.currency ?? 'USD'
  return `${input.tier.name} · ${input.offer.multiplier}x · deposit ${input.tier.deposit.toLocaleString()} ${currency} → balance ${input.tier.tradingBalance.toLocaleString()} ${currency} · drawdown ${input.offer.drawdownTriggerPercent}% · leverage 1:${input.offer.leverage}`
}
